import Link from "next/link";
import React from "react";
import { MdOutlineArrowRightAlt } from "react-icons/md";
import { asText } from "@prismicio/client";

const bodyComponent = {
  heading4: ({ children }) => (
    <h4 className="text-base text-[#1F2223]">{children}</h4>
  ),
  heading5: ({ children }) => (
    <h5 className="text-base text-[#1F2223]">{children}</h5>
  ),
  heading6: ({ children }) => (
    <h6 className="text-base text-[#1F2223]">{children}</h6>
  ),
  paragraph: ({ children }) => (
    <p className="text-base text-[#1F2223]">{children}</p>
  ),
  strong: ({ children }) => (
    <strong className="font-semibold">{children}</strong>
  ),
};

const PracticeAreaCard = ({ data }) => {
  return (
    <Link href={`/practice-areas/${data.uid}`} className="group">
      <div className="flex gap-[10px] items-center">
        <h4 className="title-medium font-title text-[#B78562] md:text-[#1F2223] group-hover:text-[#B78562]">
          {data?.data?.practice_title}
        </h4>
        <MdOutlineArrowRightAlt
          size={22}
          className="text-[#B78562] md:text-[#1F2223] group-hover:text-[#B78562]"
        />
      </div>
      <div className="mt-1 md:mt-[10px]">
        <p className={"line-clamp-[7]"}>{asText(data?.data?.excerpt)}</p>
      </div>
    </Link>
  );
};

export default PracticeAreaCard;
